import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Container, Grid, Icon, List, Segment} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';

const {getWtsCourseDocs, getWtsCourseDocFile, clearWtsCourseDocs} = Actions;

const WtsCourseDocuments = ({courseToEdit}) => {
  const dispatch = useDispatch();
  const courseId = courseToEdit?.course_id || courseToEdit?.idCursoReferencia;

  const {courseDocs, currentDocFile} = useSelector((state) => ({
    'courseDocs': state.wtsCourseDocuments.courseDocuments?.data ||
      state.wtsCourseDocuments.courseDocuments || [],
    'currentDocFile': state.wtsCourseDocuments.currentDocFile,
  }));

  const processedDocRef = useRef(null);

  useEffect(() => {
    if (courseId) {
      dispatch(getWtsCourseDocs(courseId));
    }
    return () => {
      dispatch(clearWtsCourseDocs());
    };
  }, [courseId, dispatch]);

  useEffect(() => {
    if (
      currentDocFile?.answers?.fileBase64 &&
      currentDocFile?._id !== processedDocRef.current
    ) {
      processedDocRef.current = currentDocFile?._id;
      const byteChars = atob(currentDocFile.answers.fileBase64);
      const byteArray = new Uint8Array([...byteChars].map((c) => c.charCodeAt(0)));
      const blob = new Blob([byteArray], {'type': 'application/pdf'});
      window.open(URL.createObjectURL(blob));
    }
  }, [currentDocFile]);

  const getDocType = (category) => {
    const types = {
      'studyDocument': 'STUDY_MATERIAL',
      'quiz': 'QUIZ',
      'preEvaluationForm': 'PRE_EVALUATION',
    };
    return types[category] || 'OTHER';
  };

  const handleOpenDoc = (e, mongoId) => {
    e.preventDefault();
    processedDocRef.current = null;
    dispatch(getWtsCourseDocFile(mongoId));
  };

  const renderSection = (title, type) => {
    const sectionDocs = courseDocs.filter((d) => d.doc_type === getDocType(type));

    return (
      <Grid.Column>
        <Segment
          padded
          style={{
            'height': '100%', 'backgroundColor': '#f9fafb',
            'border': '1px solid #e0e0e0', 'boxShadow': 'none',
          }}
        >
          <div
            style={{
              'borderBottom': '1px solid #ddd',
              'paddingBottom': '8px',
              'marginBottom': '10px',
              'display': 'flex',
              'alignItems': 'center',
              'color': '#2185d0',
              'fontWeight': 'bold',
              'fontSize': '1.1em',
            }}
          >
            <Icon name="tag" style={{'marginRight': '8px'}} />
            <span>{title}</span>
          </div>

          <Container fluid style={{'marginTop': '15px'}}>
            {sectionDocs.length > 0 ? (
              <List divided relaxed selection>
                {sectionDocs.map((doc, idx) => (
                  <List.Item
                    key={idx}
                    onClick={(e) => handleOpenDoc(e, doc.mongo_id)}
                    style={{'padding': '10px 5px', 'display': 'flex', 'alignItems': 'center'}}
                  >
                    <Icon
                      name="file pdf outline"
                      color="red"
                      size="large"
                      style={{'marginRight': '10px'}}
                    />
                    <List.Content>
                      <span
                        style={{
                          'color': '#2185d0',
                          'cursor': 'pointer',
                          'fontWeight': '500',
                        }}
                      >
                        {doc.file_name}
                      </span>
                    </List.Content>
                  </List.Item>
                ))}
              </List>
            ) : (
              <div style={{'textAlign': 'center', 'color': 'grey', 'padding': '20px 0'}}>
                <Icon name="info circle" size="large" style={{'marginBottom': '10px'}} />
                <p>Sin documentos disponibles</p>
              </div>
            )}
          </Container>
        </Segment>
      </Grid.Column>
    );
  };

  return (
    <Card raised fluid style={{'boxShadow': 'none', 'border': 'none'}}>
      <Card.Content>
        <Grid columns={3} divided stackable>
          <Grid.Row stretched>
            {renderSection('Documentos de Estudio', 'studyDocument')}
            {renderSection('Cuestionarios', 'quiz')}
            {courseToEdit?.pre_evaluation_needed !== 0 &&
              renderSection('Formularios Pre Evaluación', 'preEvaluationForm')
            }
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
};

export default WtsCourseDocuments;
